import styled from "styled-components";

type TProps = {
  height: number;
};

export const Spacer = styled.div`
  height: ${(props: TProps) => `${props.height}px`};
`;
